import { stylesheet } from 'typestyle';
import { Loader } from '@traceair/tds';
import { ScheduledFlight } from '../../../../../types';
import { useUploadStore } from '../../../../../store/uploadStore';
import { ProjectData } from '../../types';
import { FlightUploadHeader } from './FlightUploadHeader';
import { useUploadType } from './useUploadType';
import { FlightUploadFields } from './FlightUploadFields';
import { FlightUploadFiles } from './FlightUploadFiles';

const css = stylesheet({
  header: {
    margin: '0 0 24px',
  },
  loader: {
    height: 160,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

interface Props extends ProjectData {
  schedule?: ScheduledFlight;
  isPano: boolean;
}

export const FlightUpload = ({ customer, site, schedule, isPano }: Props) => {
  const { getUpload, getProjectDate, getRegistrationRequests, setProjectDate, getGeoref } = useUploadStore();

  const upload = getUpload(isPano, customer.id, site.id, schedule?.airtableRecordId);
  const georef = getGeoref(customer.id, site.id, schedule?.airtableRecordId);
  const projectDate = getProjectDate(isPano, customer.id, site.id, schedule?.airtableRecordId);
  const { showTypeSelect, uploadType, setUploadType } = useUploadType(upload, georef, schedule, isPano);

  const registrationRequests = getRegistrationRequests(isPano, customer.id, site.id, schedule?.airtableRecordId);

  return (
    <div data-intercom-target="FlightUpload">
      <header className={css.header}>
        <FlightUploadHeader site={site} isPano={isPano} upload={upload} schedule={schedule} />

        <FlightUploadFields
          isPano={isPano}
          customer={customer}
          site={site}
          schedule={schedule}
          showTypeSelect={showTypeSelect}
          projectDate={projectDate}
          setProjectDate={setProjectDate}
          registrationRequests={registrationRequests}
          upload={upload}
          georef={georef}
          uploadType={uploadType}
          setUploadType={setUploadType}
        />
      </header>

      {upload?.meta.restoringUpload ? (
        <div className={css.loader}>
          <Loader />
        </div>
      ) : (
        <>
          <FlightUploadFiles
            isPano={isPano}
            customer={customer}
            site={site}
            schedule={schedule}
            projectDate={projectDate}
            registrationRequests={registrationRequests}
            upload={upload}
            uploadType={uploadType}
          />
        </>
      )}
    </div>
  );
};
